
import { ReactJsonEditor } from "@/src/components";
import { DataTable, List, ReferenceField, TextField, useInput, useCreatePath } from "react-admin"
import { Content } from "vanilla-jsoneditor";
import { Box, Button, Grid } from "@mui/material";
import { TenantSelector } from "./TenantSelector";
import { useState } from "react";



export function MailBatchQueryJsonInput(props: any) {


    const { field } = useInput(props)

    const handleChange = (content: any, previousContent: Content, OnChangeStatus: any) => {

        if (content.json) {
            field.onChange(JSON.stringify(content.json))
        } else {
            field.onChange(content.text)
        }
    }

    const handleTenantInsert = (tenantId: string | null) => {
        let queryObject = {};
        try {
            queryObject = field.value ? JSON.parse(field.value) : {};
        } catch { queryObject = {}; }

        if (tenantId) {
            queryObject = { ...queryObject, tenant: tenantId };
        } else {
            const { tenant, ...rest } = queryObject as any;
            queryObject = rest;
        }

        field.onChange(JSON.stringify(queryObject, null, 2));
    };

    const [previewQuery, setPreviewQuery] = useState<string>();

    return (
        <Box>

            <ReactJsonEditor
                content={{ text: field.value }}
                onChange={handleChange}
            />
            <Grid container spacing={1} sx={{ backgroundColor: '#edeff3ff', px: 1, py: 1 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <TenantSelector
                        onSelectTenant={handleTenantInsert}
                        label="Insert Tenant into Query"
                        size="small"

                    />

                </Grid>
                <Grid size={{ xs: 12, md: 6 }} display={"flex"}>

                    <Button variant="contained"
                        onClick={() => {

                            setPreviewQuery((prev) => prev == field.value ? prev + " " : field.value);
                        }}
                        sx={{ height: '28px', fontSize: '0.7rem', minWidth: '60px', alignSelf: "center" }}
                    >
                        Preview
                    </Button>

                </Grid>
            </Grid>
            {previewQuery &&
                <Box p={1}>
                    <UsersPreview query={previewQuery} key={previewQuery} />
                </Box>
            }
        </Box>
    )
}

const validUser = {
    verified: true,
    deleted: { $ne: true },
    adminBlocked: { $ne: true },
    fake: { $ne: true },
    "settings.accountVisibility": { $in: ["all", "registered", "hidden"] },
}

const UsersPreview = ({ query }: { query: string }) => {
    const createPath = useCreatePath();

    const $query = JSON.stringify({
        ...JSON.parse(query),
        ...validUser
    });



    const handleRowClick = (id: any): false => {
        const editPath = createPath({ resource: 'user', id, type: 'edit' });
        const url = `${window.location.origin}${editPath}`;
        window.open(url, '_blank');
        return false;
    };

    return (
        <List resource="user" filter={{ $query }} exporter={false} actions={undefined}>
            <DataTable
                bulkActionButtons={false}
                rowClick={handleRowClick}
            >
                <DataTable.Col source="email" />
                <DataTable.Col source="profile.nickname" label="Nickname" />
                <DataTable.Col label="City" >
                    <ReferenceField source="profile.city" reference="city">
                        <TextField source="name" />
                    </ReferenceField>
                </DataTable.Col>
            </DataTable>
        </List>
    )
}
